import { Box } from '@mui/material'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import { useEffect } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { getCart } from 'services/api/modules/recruitment/cart'
import CartButton from '../component/CartButton'
import CreateJobAdsButton from '../component/CreateJobAdsButton'
import JobAds from '../component/JobAds'

const RecruitmentDashboard = () => {
  // API CALL
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getCart')
    queryClient.resetQueries('getCart')
  }, [])

  const {
    isLoading: cartIsLoading,
    error: cartError,
    data: cartData,
  } = useQuery(
    ['getCart'],
    async () => {
      const { data } = await getCart(1000, 1)

      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const totalInCart = cartData?.data?.length

  return (
    <DashboardContainer headerTitle="Applicant Tracking" blockMobile>
      <Box sx={{ width: '100% ', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <CreateJobAdsButton />
        {/* <Box sx={{ width: 1 / 3 }}>
            <CartButton totalInCart={totalInCart} error={cartError} isLoading={cartIsLoading} />
          </Box> */}
        <JobAds totalInCart={totalInCart ?? '0'} />
      </Box>
    </DashboardContainer>
  )
}
export default RecruitmentDashboard
